import lockhostRequest from '@/common/lockhostRequest'

export default {
  getSKEY: params => {
    return lockhostRequest({
      url: '/reg',
      method: 'get',
      params
    })
  },
  getComlist: params => {
    return lockhostRequest({
      url: '/comlist',
      method: 'get',
      params
    })
  },
  getOpen: params => {
    return lockhostRequest({
      url: '/open',
      method: 'get',
      params
    })
  },
}


// WEBPACK FOOTER //
// ./src/api/modules/fingerprint.js